import { RecipeIngredientCompatibility, RecipeIngredientReplacementMode, } from "../../../OrderFlow/OrderFlowProvider/OrderFlowTypes";
import { DialogTabs } from "../ItemDetail/ItemDetail-types";
export var ItemCardType;
(function (ItemCardType) {
    ItemCardType[ItemCardType["Recipe"] = 0] = "Recipe";
    ItemCardType[ItemCardType["Product"] = 10] = "Product";
})(ItemCardType || (ItemCardType = {}));
export var ItemCardText;
(function (ItemCardText) {
    ItemCardText["SUBSCRIBE"] = "Subscribe";
    ItemCardText["CUSTOMIZE"] = "Customize";
})(ItemCardText || (ItemCardText = {}));
export const stripHtml = (value) => value.replace(/(<([^>]+)>)/gi, "");
export const handleClick = (setDialogContentMode, setIsDetailDialogOpen, isDetailDialogOpen, 
//General tab opens by default
initTab = DialogTabs.GENERAL) => () => {
    setDialogContentMode(initTab);
    if (!isDetailDialogOpen) {
        setIsDetailDialogOpen(true);
    }
};
/**
 * Returns the default selected option for all ingredient options. The default selected is the option with the lowest sequence number
 *
 * @param itemIngredients
 * @returns
 */
export const getIngredientOptionsWithLowestSequence = (itemIngredients) => {
    let lowestOptions = [];
    if (!itemIngredients) {
        return lowestOptions;
    }
    for (const itemIngredient of itemIngredients) {
        // Find the option(s) with the lowest sequence
        let minSequence = 1;
        let currentLowestOptions = [];
        for (const option of itemIngredient.IngredientOptions) {
            if (option.IngredientOptionSeq < minSequence) {
                minSequence = option.IngredientOptionSeq;
                currentLowestOptions = [option];
            }
            else if (option.IngredientOptionSeq === minSequence) {
                currentLowestOptions.push(option);
            }
        }
        // Add the lowest options for this ingredient to the array
        lowestOptions.push(...currentLowestOptions);
    }
    return lowestOptions;
};
/**
 * Get the current compatibility type and symbol for the recipe or assignment based on dietary preferences, automatic and user replacements.
 *
 * @param compatibilityType
 * @param recipeAssignment
 * @param recipe
 * @param ingredientsToReplace
 * @param omissions
 * @param recipeIngredientReplacementMode
 * @param enableCustomization
 * @param productAndRecipeCardLayoutSettings
 * @param recipeAutoSelection
 * @returns
 */
export const getCurrentCompatibilityType = (compatibilityType, userSelectionPresent, ingredientsToReplace, omissions, recipeIngredientReplacementMode, enableCustomization, productAndRecipeCardLayoutSettings, recipeAutoSelection) => {
    let compatibilitySymbol = {};
    const isRIRMandAutoSelect = recipeIngredientReplacementMode == RecipeIngredientReplacementMode.ENABLED && recipeAutoSelection;
    if (ingredientsToReplace) {
        ingredientsToReplace.forEach((ing) => {
            var _a;
            let incompatibleIngredientCount = 0;
            for (const option of ing.IngredientOptions) {
                if ((_a = option.IngredientMajorRelations) === null || _a === void 0 ? void 0 : _a.some((id) => omissions === null || omissions === void 0 ? void 0 : omissions.includes(id))) {
                    //If this ingredient option contains a matching dislike, it's incompatible with user omissions. count it.
                    incompatibleIngredientCount++;
                }
            }
            if (incompatibleIngredientCount === ing.IngredientOptions.length) {
                //If all ingredient options contains a matching dislike, recipe should show as conflicted.
                compatibilityType = RecipeIngredientCompatibility.CONFLICT;
                return;
            }
            if (incompatibleIngredientCount > 0) {
                //If at least one ingredient option contains a matching dislike, recipe should show as modified.
                compatibilityType = RecipeIngredientCompatibility.MODIFIED;
                return;
            }
        });
    }
    let isCustomizationMade = enableCustomization && userSelectionPresent;
    switch (compatibilityType) {
        case RecipeIngredientCompatibility.MATCH:
            compatibilitySymbol.icon =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsGoodMatchIcon
                    : productAndRecipeCardLayoutSettings.MatchIcon;
            compatibilitySymbol.color =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsGoodMatchIconColor
                    : productAndRecipeCardLayoutSettings.MatchIconColor;
            compatibilitySymbol.tooltip =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsGoodMatchIconTooltipContent
                    : productAndRecipeCardLayoutSettings.MatchIconTooltipContent;
            break;
        case RecipeIngredientCompatibility.MODIFIED:
            compatibilitySymbol.icon =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsModifiedIcon
                    : productAndRecipeCardLayoutSettings.ModifiedIcon;
            compatibilitySymbol.color =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsModifiedIconColor
                    : productAndRecipeCardLayoutSettings.ModifiedIconColor;
            compatibilitySymbol.tooltip =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsModifiedIconTooltipContent
                    : productAndRecipeCardLayoutSettings.ModifiedIconTooltipContent;
            break;
        case RecipeIngredientCompatibility.CONFLICT:
            compatibilitySymbol.icon =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsNoMatchIcon
                    : productAndRecipeCardLayoutSettings.ConflictIcon;
            compatibilitySymbol.color =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsNoMatchIconColor
                    : productAndRecipeCardLayoutSettings.ConflictIconColor;
            compatibilitySymbol.tooltip =
                isRIRMandAutoSelect && enableCustomization
                    ? productAndRecipeCardLayoutSettings.IngredientOptionsNoMatchIconTooltipContent
                    : productAndRecipeCardLayoutSettings.ConflictIconTooltipContent;
            break;
    }
    if (isCustomizationMade) {
        compatibilitySymbol.icon = productAndRecipeCardLayoutSettings.IngredientOptionsManualSelectionIcon;
        compatibilitySymbol.color = productAndRecipeCardLayoutSettings.IngredientOptionsManualSelectionIconColor;
        compatibilitySymbol.tooltip = productAndRecipeCardLayoutSettings.IngredientOptionsManualSelectionIconTooltipContent;
        compatibilityType = RecipeIngredientCompatibility.CUSTOMIZED;
    }
    return { compatibilitySymbol, compatibilityType };
};
// Function to extract numeric value and unit from a string.
const extractNumericValueAndUnit = (value) => {
    if (typeof value === "string") {
        const match = value.match(/^(\d*\.?\d+)([a-zA-Z%]*)$/);
        if (match) {
            return { numericValue: parseFloat(match[1]), unit: match[2] };
        }
    }
    else if (typeof value === "number") {
        return { numericValue: value, unit: "" };
    }
    return { numericValue: 0, unit: "" };
};
/**
 * Gets the height of the title section based on the typography settings,
 * creating a consistent title section height across all cards.
 * @param typography The typography theme object to use for the calculation.
 * @param variant The typography variant upon which to base the calculation. The default is h4 based on the initial use case.
 * @param numberOfLines The number of lines to calculate the height for. The default is 2, based on the initial use case.
 * @returns
 */
export const getTitleSectionHeight = (typographyTheme, typographyVariant = "h4", numberOfLines = 2) => {
    // Get the line height and font size values as numbers and collect the unit type.
    const { numericValue: lineHeightValue } = extractNumericValueAndUnit(typographyTheme[typographyVariant].lineHeight);
    const { numericValue: fontSizeValue, unit: fontSizeUnit } = extractNumericValueAndUnit(typographyTheme[typographyVariant].fontSize);
    // Calculate the height for two rows and add a little extra based on the font size.
    const heightValue = lineHeightValue * numberOfLines + fontSizeValue * 0.03;
    const finalHeight = `${heightValue}${fontSizeUnit || "px"}`;
    return finalHeight;
};
